export default "__VITE_ASSET__BCTCB_b4__"